import { render } from "./createmodel.vue?vue&type=template&id=5d882af3"
import script from "./createmodel.vue?vue&type=script&lang=js"
export * from "./createmodel.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__